<template>
  <v-page page="Reports" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-1>
                  <v-flex align-center>
                    <div
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Reports</div>
                    <!-- <div
                    v-if="BAN !== 'all'"
                      v-show="showResetBtn && !loading"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >
                      Tickets for Account # {{ BAN }}
                    </div>-->
                  </v-flex>
                  <v-flex align-center xs8>
                    <v-layout row>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlCategory"
                          v-model="filters.CategoryId"
                          item-text="Text"
                          item-value="Value"
                          label="Category"
                          clearable
                          @change="filterReports"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlUsername"
                          v-model="filters.SubmitBy"
                          item-text="Text"
                          item-value="Text"
                          label="Submitted By"
                          clearable
                          @change="filterReports"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex xs3 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterReports"
                          ></v-text-field>
                          <v-btn @click="filterReports" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->
                      <a
                        style="text-decoration: none"
                        class="align-center"
                        @click="paginationUpdated"
                      >REFRESH</a>
                      <!-- <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="exportToExcel"
                          target="_blank"
                          >EXPORT TO EXCEL</a
                        >
                        <v-btn class="TierButton mb-1 mr-2 ml-1" @click="exportToExcel">
                      <v-icon>fa-file-excel</v-icon> &nbsp; Excel-->
                      <!-- </v-btn> -->
                      <!-- <v-btn class="TierButton mb-1 mr-0 ml-1" @click="openCreateTicketForm">
                        + New Ticket
                      </v-btn>-->
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- SERVICES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="reports"
                  :item-key="reports.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="categoryClass(props.item.CategoryName)">
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["CategoryName"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["ReportId"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["Name"] }}</text-highlight>
                      </td>

                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["LastSubmitDate"] | formatDateTime}}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["SubmitBy"] != null? props.item["SubmitBy"] : "SYSTEM"}}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <div v-if="(props.item.StatusId=='A4')||(props.item.Output != null)">
                          <text-highlight :queries="searchHighlight">{{ props.item["Output"] }}</text-highlight>
                        </div>

                        <div
                          v-if="(props.item.StatusId !='A4')&&(props.item.Output == null)"
                          :class="[{'green--text':props.item.StatusId=='A4'},{'purple--text':props.item.StatusId=='A0'},{'red--text':props.item.StatusId=='A1'} ]"
                        >{{ props.item["Status"] }}</div>
                      </td>
                      <!-- <td
                        class="text-xs-left px-0"
                        :class="[{'green--text':props.item.StatusId=='A4'},{'purple--text':props.item.StatusId=='A0'},{'red--text':props.item.StatusId=='A1'} ]"
                      ><text-highlight :queries="searchHighlight">{{ props.item["Status"] }}</text-highlight></td>-->
                      <td class="justify-end align-center text-xs-right pl-1 pr-0 pt-0 pb-0">
                        <v-layout row>
                          <v-flex
                            xs10
                            v-if="(props.item.StatusId !== 'A0')&&(props.item.StatusId !== 'A2')&&(props.item.StatusId !== 'A1')"
                          >
                            <a
                              v-if="(props.item.Runnable == true) && (props.item.ReportInstanceId ? props.item.StatusId == 'A4': true)"
                              class="mr-3"
                              style="text-decoration: none"
                              @click="runReport(props.item)"
                            >RUN</a>
                            <router-link
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openViewReport(props.item)"
                            >VIEW</router-link>
                            <a
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="mr-3"
                              style="text-decoration: none"
                              @click="exportToExcel(props.item)"
                            >EXCEL</a>
                            <a
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="mr-3"
                              style="text-decoration: none"
                              @click="exportToCSV(props.item)"
                            >CSV</a>
                          </v-flex>

                          <v-flex
                            xs7
                            v-if="(props.item.ReportInstanceId) && (props.item.StatusId != 'A4')"
                          >
                            <v-progress-linear
                              :indeterminate="true"
                              class="align-center fill-height my-2"
                            ></v-progress-linear>
                          </v-flex>
                          <v-flex
                            v-if="(props.item.ReportInstanceId) && (props.item.StatusId != 'A4')"
                            class="mx-2"
                          >
                            <a
                              class="ml-0 align-center"
                              style="text-decoration: none"
                              @click="cancelReport(props.item)"
                            >CANCEL</a>
                          </v-flex>
                          <v-flex>
                            <router-link
                              class="ml-0 align-center"
                              style="text-decoration: none"
                              :to="openReportHistory(props.item)"
                            >HISTORY</router-link>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetReportsList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <createTicket ref="createTicket"></createTicket> -->
    <reportRun ref="reportRunReports"></reportRun>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import reportRun from "./ReportRun.vue";
import Bus from "../../bus";
import TextHighlight from "vue-text-highlight";
import "@/assets/css/main.css";
import Spinner from "../../components/Spinner.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Reports",

  components: {
    VPage,
    reportRun,
    "text-highlight": TextHighlight,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,

    showResetBtn: false,
    filters: {},
    filtersChanged: false,

    reports: [],
    ddlCategory: [],
    ddlUsername: [],
    searchHighlight: "",

    rowsPerPageItems: [
      30,
      45,
      60,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    // Selected by default
    pagination: {
      rowsPerPage: -1,
      descending: false,
      totalRecords: 0,
      sortBy: "CategoryName",
      page: 1
    },

    breadcrumb: [
      {
        text: "Reports",
        disabled: false,
        href: "#/reports"
      },
      {
        text: "All",
        disabled: true,
        href: "#/reports"
      }
    ],

    headers: [
      {
        text: "Category",
        value: "CategoryName",
        width: "12%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Report ID",
        value: "ReportId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Name",
        value: "Name",
        // sortable: false,
        width: "26%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Last Submitted",
        value: "LastSubmitDate",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "By",
        value: "SubmitBy",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Output",
        value: "Output",
        width: "23%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      // {
      //   text: "Status",
      //   value: "Status",
      //   // sortable: false,
      //   width: "10%",
      //   fixed: true,
      //   align: "left",
      //   class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      // },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "21%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  mounted() {
    this.interval = setInterval(this.paginationUpdated, 15000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};
      this.selectedRow = null;

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
    }

      this.breadcrumb[1].text = "all";
      this.filtersChanged = true;
      this.showResetBtn = false;

      //inits drop down filter lists
      this.getDropDownLists();

      await this.paginationUpdated();

      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    getDropDownLists() {
      axios.get("/api/Report/GetReportDDLs/").then(res => {
        this.ddlCategory = res.data.ddlCategory;
        this.ddlUsername = res.data.ddlUsername;
      });
    },
    async resetReportsList() {
      this.loading = true;
      this.$router.push("/reports");

      this.filters = {};
      this.filtersChanged = true;
      this.searchHighlight = "";
      this.search = "";
      this.breadcrumb[1].text = "all";
      this.BAN = "all";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async filterReports() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Report/GetPagedReportList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.reports = response.data.reports;
          this.pagination.totalRecords = response.data.pagination.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    openReportHistory(item) {
     return "/report-history/" + item.ReportId;
    },
    cancelReport(item) {
      var confirmCancel = confirm(
        "Are you sure you would like to cancel the submitted report?"
      );
      if (confirmCancel == true) {
        var reportInstanceId = item.ReportInstanceId;

        axios.post("/api/Report/cancelReport/" + reportInstanceId).then(res => {
          this.paginationUpdated();
        });
      }
    },
    async runReport(item) {
      var reportId = item.ReportId;
      if (
        reportId == "all" ||
        typeof reportId == "undefined" ||
        reportId == null
      ) {
        //do nothing
      } else {
        await axios
          .get("/api/Report/getReportParameters/" + reportId)
          .then(res => {
            var autorun = res.data.autorun;
            if (autorun == true) {
              this.$refs.reportRunReports.open({
                autorun: autorun,
                reportId: reportId,
                reportParameters: null,
                reportName: item.Name
              });
            } else if (autorun == false) {
              var reportParameters = res.data.runReportFormParameters;

              this.$refs.reportRunReports.open({
                autorun: autorun,
                reportId: reportId,
                reportParameters: reportParameters,
                reportName: item.Name
              });
            }
          });
      }
    },
    categoryClass(item) {
      if (item) {
        var categoryClass;
        categoryClass = item
          .split(" ")
          .join("")
          .replace("/", "");
        return categoryClass;
      }
    },
    openViewReport(item) {
      return "/report-view/" + item.ReportId + "/" + item.ReportInstanceId;
    },
    exportToExcel(item) {
      var reportInstanceId = item.ReportInstanceId;
      var reportTitle = item.Name;
      var reportId = item.ReportId;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToExcel/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportId + " - " + reportTitle + "." + currentDate + ".xlsx"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    exportToCSV(item) {
      var reportInstanceId = item.ReportInstanceId;
      var reportTitle = item.Name;
      var reportId = item.ReportId;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToCSV/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportId + " - " + reportTitle + "." + currentDate + ".csv"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/deep/ tr:hover{
  background-color:#EEEEEE!important;
}
/deep/ table.v-table tbody tr.ACCOUNTING:nth-child(odd){
  background-color: #ecf0f8;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.ACCOUNTS:nth-child(odd){
  background-color: #fdf1ea;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.FINANCIAL:nth-child(odd)  {
  background-color: #f6f6f6;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.HARDALARMS:nth-child(odd) {
  background-color: #fff8e5;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.OPERATIONAL:nth-child(odd)  {
  background-color: #eef5fb;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(odd)  {
  background-color: #f0f7ec;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(odd)  {
  background-color: #ffe3e6;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(odd)  {
  background-color: #fff5cd;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(odd)  {
  background-color: #d9e2f3;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(odd)  {
  background-color: #fbe5d6;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(odd)  {
  background-color: #ededed;
  /* background-color:#dbdbdb; */
}
/deep/ table.v-table tbody tr.ACCOUNTING:nth-child(even){
  background-color: #ecf0f885;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.ACCOUNTS:nth-child(even){
  background-color: #fdf1ea81;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.FINANCIAL:nth-child(even)  {
  background-color: #f6f6f679;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.HARDALARMS:nth-child(even) {
  background-color: #fff8e581;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.OPERATIONAL:nth-child(even)  {
  background-color: #eef5fb7e;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(even)  {
  background-color: #f0f7ec81;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(even)  {
  background-color: #ffe3e67e;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(even)  {
  background-color: #fff5cd81;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(even)  {
  background-color: #d9e2f37e;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(even)  {
  background-color: #fbe5d680;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(even)  {
  background-color: #ededed80;
  /* background-color:#dbdbdb; */
}

</style>
